<script setup lang="ts">
import SubMenuDesktopLayout from '~/components/App/NewHeader/Layouts/DesktopMenu/index.vue'
import HeaderMain from '~/components/App/NewHeader/HeaderMain/index.vue'
import HeaderSide from '~/components/App/NewHeader/HeaderSide/index.vue'
import Icon from '~/components/Icon/Legacy/index.vue'
import ReadMore from '~/components/App/NewHeader/ReadMode/index.vue'

interface Iprops {
  alt?: boolean
}

const props = defineProps<Iprops>()

const itemsHeaderSide: InstanceType<typeof HeaderSide>['$props']['items'] = [
  {
    title: 'AI Recipe Creates World War I Weapon',
    text: 'Plus, create an AI avatar of yourself with HeyGen\'s latest tool...',
    imageUrl: 'https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/06bfc9d5-a26f-461a-9641-57ac35aba16c/Group_4328.png',
    url: 'https://thedailybite.co/p/ai-recipe-creates-world-war-i-weapon',
  },
  {
    title: 'Can AI Find You A Girlfriend?',
    text: 'How AI may improve your chances to match with someone on Tinder...',
    imageUrl: 'https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/6528e108-b6b4-4515-a8de-f48aeb995a44/tinder.png',
    url: 'https://thedailybite.co/p/can-ai-find-you-a-girlfriend',
  },
  {
    title: 'Google Is Your Government Now',
    text: 'Pledge allegiance to the search engine...',
    imageUrl: 'https://media.beehiiv.com/cdn-cgi/image/format=auto,width=800,height=421,fit=scale-down,onerror=redirect/uploads/asset/file/5e5b7006-e26d-452a-a0f3-a0b85b5ec3f9/new_government.png',
    url: 'https://thedailybite.co/p/google-is-your-government-now',
  },
]

const openMenuState = useHeaderMenusActive()
const isOpen = computed(() => openMenuState.value.theDailyBite)
</script>

<template>
  <SubMenuDesktopLayout :active="isOpen" :alt="props?.alt">
    <template #main>
      <HeaderMain
        subtitle="The Daily Bite"
        subtitle-icon-background="#d7f55fbf"
        title="The Fastest Growing AI Newsletter"
        description="Join 200,000+ readers and learn how AI and emerging tech can improve your life in just 3 minutes a day"
      >
        <template #image>
          <img class="image" src="~/assets/images/LucasHire/5e943c83379955d482b4c6f1082ef3d1.webp">
        </template>

        <template #subtitleIcon>
          <div class="subtitle-icon">
            <ClientOnly>
              <video width="18px" height="18px" autoplay loop muted playsinline>
                <source src="~/assets/images/the_daily_bite.webm" type="video/webm">
                Seu navegador não suporta a exibição de vídeos.
              </video>
            </ClientOnly>
          </div>
        </template>

        <template #buttons>
          <div class="daily-bite-container-buttons">
            <ReadMore href="https://thedailybite.co/" class="<lg:m-0 lg:m-lauto" />
            <iframe src="https://embeds.beehiiv.com/d8b64ae4-c348-4bb7-80f2-09223d959797?slim=true" data-test-id="beehiiv-embed" height="52" frameborder="0" scrolling="no" style="margin: 0; border-radius: 0px !important; background-color: transparent; width: 100%;" />
          </div>
        </template>

        <template #contentBottom>
          <div class="content-bottom-text">
            <p>Read by +200K Professionals Around The World</p>
          </div>

          <div class="content-bottom-items">
            <div class="content-bottom-item">
              <Icon name="microsoft-logo" w-80px />
              <Icon name="coinbase-logo" w-70px />
            </div>
            <div class="content-bottom-item">
              <Icon name="goldman-logo" w-60px />
              <Icon name="jpmorgan-logo" w-60px />
            </div>
            <div class="content-bottom-item">
              <Icon name="shutterstock-logo" w-60px />
              <Icon name="tickpick-logo" w-60px />
            </div>
            <div class="content-bottom-item">
              <Icon name="trustbank-logo" w-80px />
              <Icon name="techable-logo" w-60px />
            </div>
            <div class="content-bottom-item">
              <Icon name="a16z-logo" w-40px />
              <Icon name="scale-logo" w-60px />
            </div>
          </div>
        </template>
      </HeaderMain>
    </template>

    <template #aside>
      <HeaderSide
        type="small"
        title="Featured Posts"
        url-btn-see-all="https://thedailybite.co/"
        icon-btn-see-all="arrow-thin"
        text-btn-see-all="See All"
        :items="itemsHeaderSide"
      />
    </template>
  </SubMenuDesktopLayout>
</template>

<style scoped lang="scss">
.subtitle-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(215, 245, 95, 0.75);
}

.image {
  border-radius: 8px;
}

.daily-bite-container-buttons {
  width: 100%;
  display: flex;
  align-items: center;

  .daily-bite-button-read-more {
    --at-apply: text-bluish-darker;
    min-width: 100px;
    display: flex;
    align-items: center;
    gap: 5px;
    font-family: 'Circular Std Bold';
    font-size: 14px;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: -0.48px;
    font-feature-settings: 'ss02' on, 'ss01' on,'salt' on;

    svg {
      --at-apply: fill-bluish-darker;
      width: 11px;
      height: 11px;
      transform: rotate(-90deg);
    }
  }
}

.content-bottom-text {
  font-family: 'Inter';
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'cv01' on, 'cv09' on;
  line-height: 175%;
  padding: 0 40px 0 0;
  --at-apply: text-bluish-darker;
}
.content-bottom-items {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px 40px;

  .content-bottom-item {
    width: calc(100% / 8);
    svg:nth-child(1) {
      margin: 0 0 20px 0;
    }
  }
}
@media screen and (max-width: 1200px) {
  .daily-bite-container-buttons {
    flex-direction: column-reverse;
    max-width: 768px;
    gap: 25px;
  }
  .daily-bite-button-read-more {
    margin: 0 0 0 auto;
    min-width: unset;
  }
}
</style>
